<script lang="ts">
	import Link from '$lib/components/atoms/link/Link.svelte';
	import { getMagazineUrl } from '$lib/services/advertising/magazine';

	export let backgroundUrl;
	export let text;
	export let secondText = '';
	export let ctaText;
	export let ctaIcon;
	export let ctaHref = getMagazineUrl();
	export let gradient = 'linear-gradient(0deg, rgba(20, 65, 89, 0) 29.26%, rgba(20, 65, 89, 0.9) 100%)';
	export let onclick: () => void = () => {};

	let classes = '';
	export { classes as class };

</script>

<div
	data-testid="ad-magazine"
	class="magazinead-bg bg-cover bg-center p-4 b-0 rd-1 flex flex-col justify-between text-neutral-weakest min-h-184px {classes}"
	style="--gradient: {gradient}; --bg-url: url('{backgroundUrl}');"
>
	<div class="inline-flex flex-col">
		<span class="text-md">{text}</span>
		<span class="text-lg">{secondText}</span>
	</div>
	<Link
		label={ctaText}
		icon={ctaIcon}
		color="white"
		button="filled"
		class="w-fit"
		href={ctaHref}
		target="_blank"
		rel="external"
		{onclick}
	/>
</div>

<style>
	.magazinead-bg {
		background-image: var(--gradient), var(--bg-url);
	}
</style>
